// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "fareGroup__button-382sp";
var _4 = "fareGroup__button_active-guTkJ";
var _5 = "fareGroup__button_business-2Z9Ui";
var _6 = "slider__wrp-3CnJw";
var _7 = "fareGroup__slide-31e0w";
var _8 = "scroll_up-3nM5O";
var _9 = "mobileTabs-Oo5PZ";
var _a = "buttons-2piNA";
var _b = "compareFaresLink_icon-2jPwN";
var _c = "compareFaresLink-3-QMK";
var _d = "wrapper-1aRKN";
export { _1 as "__esModule", _2 as "mobile", _3 as "fareGroup__button", _4 as "fareGroup__button_active", _5 as "fareGroup__button_business", _6 as "slider__wrp", _7 as "fareGroup__slide", _8 as "scroll_up", _9 as "mobileTabs", _a as "buttons", _b as "compareFaresLink_icon", _c as "compareFaresLink", _d as "wrapper" }
export default { "__esModule": _1, "mobile": _2, "fareGroup__button": _3, "fareGroup__button_active": _4, "fareGroup__button_business": _5, "slider__wrp": _6, "fareGroup__slide": _7, "scroll_up": _8, "mobileTabs": _9, "buttons": _a, "compareFaresLink_icon": _b, "compareFaresLink": _c, "wrapper": _d }
